import React, { useEffect, useState } from 'react'
import Skeleton from '@mui/material/Skeleton'
import Invest from '../../Assets/images/wa.png'
import Line from '../../Assets/images/Line.png'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import NorthEastOutlinedIcon from '@mui/icons-material/NorthEastOutlined';
import ButtonPlus from '../SelectValue/ButtonPlus';
import SelectBank from './SelectBank';
import Withdrawal from './Withdrawal';
import SelectUserBank from './SelectUserBank';
import getServices from '../../Services/get-service';
import { toast } from 'react-toastify';
import Constant from '../../Constant'
import 'react-toastify/dist/ReactToastify.css';

function Topsec() {
  const [show, setShow] = useState(false)
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [open1, setOpen1] = useState(false)
  const handleOpen1 = () => setOpen1(true)
  const handleClose1 = () => setOpen1(false)
  const [openBankList, setOpenBankList] = useState(false)
  const handleOpenBankList = () => setOpenBankList(true)
  const handleCloseBankList = () => setOpenBankList(false)
  const [selectedBank, setSelectedBank] = useState(null)
  const [accBalance, setAccBalance] = useState(0)
  const [lB, setLB] = useState('0.0')
  const [loading, setLoading] = useState(true)
  const fetchBalance = () => {
    setLoading(true)
    getServices.getWalletBalance().then(
      (response) => {
        setLoading(false)
        if (response.data.statusCode === 200 && response.data.data.length > 0) {
          const walletData = response.data.data[0]
          setAccBalance(walletData.availableBalance)
          setLB(walletData.ledgerBalance)
        } else {
          toast.error(response.data.description)
        }
      },
      (error) => {
        setLoading(false)
        toast.error(error.response.data.description)
      }
    )
  }

  useEffect(() => {
    fetchBalance();
    window.addEventListener("walletRefresh", fetchBalance);
    return () => window.removeEventListener("walletRefresh", fetchBalance);
  }, [])
  return (

    <>
      <SelectBank
        open={open}
        handleClose={handleClose}
      />
      <SelectUserBank
        open={openBankList}
        handleClose={handleCloseBankList}
        onSelectBank={(bank) => {
          setSelectedBank(bank);
          setOpenBankList(false);
          setOpen1(true);
        }}
      />
      <Withdrawal
        open={open1}
        handleClose={handleClose1}
        handleBack={() => {
          setOpen1(false);
          setOpenBankList(true);
        }}
        bank={selectedBank}
      />
      <div className=' flex flex-col md:flex-row gap-4 my-4 rounded-lg p-3 md:p-4 border-gray-200 border w-full overflow-hidden'>

        <div className=' flex gap-3'>
          <div>
            <img src={Invest} alt='Invest' />
          </div>
          <div onClick={() => setShow(!show)}>
            <p className=' text-back-color2 text-[14px] mb-1'>Wallet Balance <span className=' pl-2 text-[#808285]'>{show ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}</span></p>
            <div className=' text-xl md:text-2xl text-back-color2'>
              {loading ? <Skeleton variant="text" width={120} height={40} /> : (show ? '*******' : `₦ ${Constant.FormatNumber(accBalance)}`)}
            </div>
            <div className=' flex justify-between'>
              <p className=' text-back-color2 text-[14px] mb-1'>Ledger Balance :</p>
              <div className=' text-[14px] text-back-color2'>
                {loading ? <Skeleton variant="text" width={80} height={20} /> : (show ? '*******' : `₦ ${Constant.FormatNumber(lB)}`)}
              </div>

            </div>
          </div>

        </div>
        <div className=' hidden md:flex flex-col justify-center'>
          <img src={Line} alt='line' />
        </div>
        <div className=' flex justify-center flex-col w-full md:w-auto'>
          <ButtonPlus
            name='Fund wallet'
            onClick={handleOpen}
          />
        </div>
        <div className=' flex justify-center flex-col w-full md:w-auto'>
          <div onClick={handleOpenBankList} className=' cursor-pointer p-3 px-4 rounded-lg pt-5 bg-[#FAFBFC] text-center md:text-left'>
            <p className=' text-[16px] text-back-color2'>Withdraw <NorthEastOutlinedIcon /></p>
          </div>
        </div>

      </div>
    </>
  )
}

export default Topsec